import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { Box, Grid2, Typography } from "@mui/material";
import Report from "./Report";

function ReportHome() {
  const [reportActiveTab, setreportActiveTab] = useState("Report");

  const handleChange = (event, newValue) => {
    setreportActiveTab(newValue);
  };

  return (
    <Grid2 container>
      <TabContext value={reportActiveTab}>
        <Grid2
          container
          sx={{ borderBottom: "1px solid lightgray", width: "100%" }}
        >
          <Tabs value={reportActiveTab} onChange={handleChange}>
            <Tab label="Report" value="Report" />
          </Tabs>
        </Grid2>

        <TabPanel value="Report" sx={{ padding: "0px", width: "100%" }}>
          <Report />
        </TabPanel>
      </TabContext>
    </Grid2>
  );
}

export default ReportHome;
